export const ACTION_TYPES = {
    API_CALL_BEGIN: 'API_CALL_BEGIN',
    API_CALL_SUCCESS: 'API_CALL_SUCCESS',
    API_CALL_ERROR: 'API_CALL_ERROR'
}

export function apiCallBegin() {
    return { type: ACTION_TYPES.API_CALL_BEGIN };
  }
  
  export function apiCallError() {
    return { type: ACTION_TYPES.API_CALL_ERROR };
  }
  
  export function apiCallSuccess() {
    return { type: ACTION_TYPES.API_CALL_SUCCESS };
  }